import * as S from './styles'

//images
import phone from '../../../assets/images/propaganda-app.png'
import google from '../../../assets/images/google-badge.png'
import apple from '../../../assets/images/apple-badge.png'

//hooks
import { useTranslation } from 'react-i18next'



function DownloadApp() {
	const { t } = useTranslation('payment')


	return (
		<S.Container>
			<S.Content>
				<S.ImageContainer>
					<S.Phone src={phone} />
				</S.ImageContainer>
				<S.Infos>
					<S.DownloadMessage>{t('DOWNLOAD_MESSAGE')}</S.DownloadMessage>
					<S.BadgesContainer>
						<a href='https://apps.apple.com/us/app/antagonista-cruso%C3%A9/id1630769331' target={'_blank'} rel='external'>
							<S.Badges src={apple} />
						</a>
						<a href='https://play.google.com/store/apps/details?id=com.antagonista' target={'_blank'} rel='external'>
							<S.Badges src={google} />
						</a>
					</S.BadgesContainer>
				</S.Infos>
			</S.Content>
		</S.Container>
	)
}

export { DownloadApp }
